import { afterNextRender, Component, ElementRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Feature } from './feature';
import { FEATURES } from '../../../shared/json';

@Component({
    selector: 'app-features',
    imports: [],
    templateUrl: './features.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './features.component.scss'
})
export class FeaturesComponent implements OnDestroy {
  features: Feature[] = FEATURES
  expanded: boolean[] = this.features.map(() => false);
  private revealObserver?: IntersectionObserver;

  constructor(private elementRef: ElementRef<HTMLElement>) {
    afterNextRender(() => this.setupRevealObserver());
  }

  isExpandable(i: number): boolean {
    return (this.features[i]?.details?.length ?? 0) > 1;
  }

  extraDetails(i: number): string {
    return (this.features[i]?.details ?? []).slice(1).join(' ');
  }

  toggleExpanded(i: number): void {
    if (!this.isExpandable(i)) {
      return;
    }
    this.expanded[i] = !this.expanded[i];
  }

  private setupRevealObserver(): void {
    this.revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          this.revealObserver?.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    this.elementRef.nativeElement
      .querySelectorAll<HTMLElement>('[data-reveal]')
      .forEach(el => this.revealObserver?.observe(el));
  }

  ngOnDestroy(): void {
    this.revealObserver?.disconnect();
  }
}
